import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  counterpartyGetBranchEmployeesService,
  getCounterpartyEmployeesListService,
} from '../services/employees.service';
import {
  TEmployeesListReqParams,
  TCounterpartyBranchesReqParams, TCounterpartyBranchEmployeesResData, TEmployeesListResData,
} from '../types/employees.types';

export const employeesQueryKeys = createQueryKeys(EQueryKeys.EmployeesQueryKeys, {
  getEmployeesList: (params: TEmployeesListReqParams | {}, counterpartyGUID: string  ) => ({
    queryKey: ['counterparties-employees-list-all', params, counterpartyGUID],
    queryFn: (): Promise<TEmployeesListResData> => getCounterpartyEmployeesListService(params, counterpartyGUID),
  }),
  getBranchEmployeesList: (counterpartyGUID: string, branchGUID: string, params?: TCounterpartyBranchesReqParams) => ({
    queryKey: ['branch-employees-list', params],
    queryFn: (): Promise<TCounterpartyBranchEmployeesResData> =>
      counterpartyGetBranchEmployeesService(counterpartyGUID, branchGUID),
  }),

  getEmployees_MultiRole: (
    params: TEmployeesListReqParams | {},
    counterpartyGUID: string,
    branchGUID: string,
    hasAccessForAllBranches?: boolean,
  ) => ({
    queryKey: ['counterparties-employees-list-all', params, counterpartyGUID, branchGUID, hasAccessForAllBranches],
    queryFn: (): Promise<TCounterpartyBranchEmployeesResData | TEmployeesListResData> => {
      if (hasAccessForAllBranches) {
        const redoParams = {
          ...params,
          ...(branchGUID ? { branch_guids: [branchGUID] } : null),
        }

        return getCounterpartyEmployeesListService(redoParams, counterpartyGUID);
      }

      return counterpartyGetBranchEmployeesService(counterpartyGUID, branchGUID);
    },
  }),
});
